import { render, staticRenderFns } from "./MavePlatforms.vue?vue&type=template&id=375c5eac&scoped=true"
import script from "./MavePlatforms.vue?vue&type=script&lang=js"
export * from "./MavePlatforms.vue?vue&type=script&lang=js"
import style0 from "./MavePlatforms.vue?vue&type=style&index=0&id=375c5eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c5eac",
  null
  
)

export default component.exports